import { Card, useTheme } from '@mui/material';

type BasicCardProps = {
  children: React.ReactNode;
};

export const BasicCard = ({ children }: BasicCardProps) => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        backgroundColor:
          theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#fcfcfc',
      }}
    >
      {children}
    </Card>
  );
};
